module.exports = __webpack_public_path__ + "img/metal_i@2x.04c039eb.png";